export enum siteRoutes {
  login = "/auth/login",
  home = "/",
  attendess = "/user-management/attendees",
  hosts = "/user-management/hosts",
  ambassadors = "/user-management/ambassadors",
  viewAmbassador = "/user-management/ambassadors/view-ambassador",
  allRequests = "/user-management/ambassadors/all-request",
  ambassadorExperiencesListing = "/user-management/ambassadors/ambassador-experiences/listing",
  createAmbassadorExperience = "/user-management/ambassadors/ambassador-experiences/create",
  viewAmbassadorExperiencesDetail = "/user-management/ambassadors/ambassador-experiences/view",
  viewAmbassadorExperiencesParticipants = "/user-management/ambassadors/ambassador-experiences/view/participants",

  viewAmbassadorEventDetail = "/user-management/ambassadors/view-ambassador/event-detail-view",
  timeSlotsAmbassador = "/user-management/ambassadors/time-slots",
  requestDetail = "/user-management/ambassadors/all-request/view",
  minors = "/user-management/minors",
  rsvps = "/user-management/rsvps",
  experiences = "/experiences",
  viewExperienceDetail = "/experiences/view-experiences-detail",
  viewExperienceAttendance = "/experiences/view-experiences-detail/attendence-view",
  // hostSubscription = "/user-management/host/subscriptions",
  // hostSubscribers = "/user-management/host/subscribers",
  createNewHost = "/user-management/host/create-new-host",
  viewHost = "/user-management/host/view-host",
  hostEventDetailView = "/user-management/host/view-host/event-detail-view",
  hostAttendenceView = "/user-management/host/view-host/event-detail-view/attendence-view",
  attendeeView = "/user-management/attendees/view-attendee",
  attendeeEvents = "/user-management/attendees/view-attendee/events",
  attendeeEventsDetail = "/user-management/attendees/view-attendee/events/view-event-details",
  viewMinors = "/user-management/minors/view-minors",
  minorEvents = "/user-management/minors/view-minors/events",
  minorEventsDetail = "/user-management/minors/view-minors/events/view-event-details",
  viewRSVP = "/user-management/rsvp/view-rsvp",
  rsvpEventsDetail = "/user-management/rsvp/view-rsvp/view-event-detail",
  rsvpEventAttendance = "/user-management/rsvp/view-rsvp/view-event-detail/rsvp-attendance",
  eventBadgeListing = "/badge-management/event-badge-listing",
  createEventBadge = "/badge-management/create-event-badge",
  achievementBadgeListing = "/badge-management/achievement-badge-listing",
  createAchievementBadge = "/badge-management/create-achievement-badge",
  coreConceptBadgeListing = "/badge-management/core-concept-badge-listing",
  createCoreConceptBadge = "/badge-management/create-core-concept-badge",

  communitiesListing = "/communities-listing",
  communitiesView = "/communities-listing/view-community",
  resourceLibraryListing = "/resource-library-listing",
  createResourceLibrary = "/resource-library/create-resource-library",
  editResourceLibrary = "/resource-library/edit-resource-library",
  cupOfGratitudeListing = "/cup-of-gratitude-listing",
  cupOfGratitudeCreate = "/cup-of-gratitude-create",
  cupOfGratitudeEdit = "/cup-of-gratitude-edit",
  businessManagementListing = "/business-management-listing",
  viewBusinessDetail = "/business-management/view-business-detail",
  teamMemberListing = "/team-management/team-member-listing",
  createTeamMember = "/team-management/create-team-member",
  editTeamMember = "/team-management/edit-team-member",
  viewTeamMember = "/team-management/view-team-member",
  roleManagementListing = "/team-management/role-management-listing",
  createRole = "/team-management/create-role",
  editRole = "/team-management/edit-role",
  notificationListing = "/notifications",
  policyAgreement = "/policy-agreement",
  editPolicy = "/edit-policy-agreement",
  ambassadorWallets = "/master-portal/ambassador-wallets",
  productItems = "/master-portal/product-items/listing-product-items",
  productItemsCreate = "/master-portal/product-items/create-product-items",
  productItemEdit = "/master-portal/product-items/edit-product-items",
  orderRequests = "/master-portal/order-requests/listing-order-requests",
  viewOrderRequest = "/master-portal/order-requests/view-order-request",

  hostSubscription = "/host-management/manage-subscriptions/listing",
  hostCancelEventsListing = "/host-management/cancel-events/listing",
  notFound ="/404",
}
